import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-default-button',
  templateUrl: './default-button.component.html',
  styleUrls: ['./default-button.component.css']
})
export class DefaultButtonComponent {

  @Input() icon: string;
  @Input() buttonText: string;
  @Input() text: string;
  @Input() disabled: boolean;


  constructor() { }


}
